<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>Задачи</div>
            </div>
            <div class="panel-body pn">
                <div class="dt-panelmenu clearfix">
                    <div class="dataTables_length filter-form-inline">
                        <div class="filter-form">
                            Клиент
                            <label class="autocomplete">
                                <autocomplete
                                    :data="client.list"
                                    v-model="client.clientSearch"
                                    :serializer="s => client.clientSearch"
                                    size="sm"
                                    placeholder="Фамилия, телефон или номер карты"
                                    @hit="clientSelect($event)"
                                >

                                    <template slot="suggestion" slot-scope="{ data }">
                                        <span>{{data.fullName}}</span>&nbsp;
                                        <small>{{ data.phone }}</small>
                                    </template>
                                </autocomplete>
                            </label>
                        </div>
                        <div class="filter-form">
                            Тип
                            <label>
                                <select v-model="filter.type_id" class="form-control input-sm">
                                    <option value="">Все</option>
                                    <option value="1">Лид</option>
                                    <option value="2">Записан на занятие</option>
                                    <option value="3">Перворзаник</option>
                                    <option value="4">Активный</option>
                                    <option value="5">Отток до 3 месяцев</option>
                                    <option value="6">Отток до 6 месяцев</option>
                                    <option value="7">Отток более 6 месяцев</option>
                                </select>
                            </label>
                        </div>
                        <div class="filter-form">
                            Статус
                            <label>
                                <select v-model="filter.complete" class="form-control input-sm">
                                    <option value="">Все</option>
                                    <option value="0">Не закрыта</option>
                                    <option value="1">Закрыта</option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>
                <grid-view
                        ref="tableList"
                        fixed-header
                        :loader="loader"
                        :filter="filter"
                        store-name="task-list"
                        defaultSort="-created_at"
                        :extraFields="['client']"
                >
                    <template #header>
                        <th>Клиент</th>
                        <th>Телефон</th>
                        <th>Текст</th>
                        <th>Дата окончания</th>
                        <th>Дата создания</th>
                        <th></th>
                        <th>Дата закрытия</th>
                        <th></th>
                    </template>
                    <template v-slot:row="{ row }">
                        <td class="fs11"><router-link target="_blank" :to="{name: 'clients-edit', params: {id: row.client_id}}">
                            {{row.client.fullName}}
                        </router-link></td>
                        <td class="fs11">{{row.client.phone}}</td>
                        <td class="fs11">{{row.text}}</td>
                        <td class="fs11">
                            <span v-if="row.end_at > 0">{{row.end_at | dateFormatTimestamp('dd.mm.yyyy HH:MM')}}</span>
                            <span v-else>---</span>
                        </td>
                        <td class="fs11">{{row.created_at | dateFormatTimestamp('dd.mm.yyyy HH:MM')}}</td>
                        <td>
                            <span class="label" :class="{'label-success': row.complete === 1, 'label-danger': row.complete === 0}">
                                {{row.complete === 0 ? 'Не закрыта' : 'Закрыта'}}
                            </span>
                        </td>
                        <td class="fs11">
                            <span v-if="row.complete_at > 0">{{row.complete_at | dateFormatTimestamp('dd.mm.yyyy HH:MM')}}</span>
                            <span v-else>---</span>
                        </td>
                        <td>
                            <drop-down-button name="Действие" classes="btn-info btn-sm">
                                <li :class="{disabled: row.complete === 1}">
                                    <a v-on:click="taskClose(row)">
                                        Закрыть
                                    </a>
                                </li>
                                <li>
                                    <a v-on:click="showCommentPopup(row)">
                                        Комментарии
                                    </a>
                                </li>
                                <li :class="{disabled: row.getHelp().length === 0}">
                                    <a v-on:click="showHelp(row)">
                                        Подсказка
                                    </a>
                                </li>
                            </drop-down-button>
                        </td>
                    </template>
                </grid-view>
            </div>
        </div>
        <modal name="task-comments" height="auto">
            <loading :active.sync="modals.comments.isLoading" :z-index="3" color="#4c4a49" :is-full-page="false"/>
            <div class="panel panel-visible">
                <div class="panel-heading">
                    <div class="panel-title hidden-xs">
                        Комментарии
                    </div>

                </div>
                <form @submit.prevent="submitComment">
                    <div class="panel-body admin-form">
                        <div class="" v-for="comment in modals.comments.list" v-bind:key="comment.id">
                            <div>{{comment.creator.fullName}} <small style="float: right">в {{comment.created_at | dateFormatTimestamp('dd.mm.yyyy HH:MM:ss')}}</small></div>
                            <div class="mb10 pb10 pl5" style="border-bottom: 1px solid #dddddd">

                                {{comment.comment}}
                            </div>
                        </div>
                        <div class="col-md-12">
                            <label class="field-label">Новый комментарий</label>
                            <label class="field">
                                <textarea class="gui-textarea" v-model="modals.comments.text"></textarea>
                            </label>
                        </div>
                    </div>

                    <div class="panel-footer admin-form">
                        <button type="submit" class="button btn-primary" :disabled="modals.comments.text.length === 0">
                            <span>Добавить</span>
                        </button>
                    </div>
                </form>

            </div>
        </modal>
        <modal name="task-help" height="auto">
            <div class="panel panel-visible">
                <div class="panel-heading">
                    <div class="panel-title hidden-xs">
                        Подсказка
                    </div>

                </div>
                <div class="panel-body admin-form">
                    <div class="col-md-12" v-html="modals.help.task.getHelp()"></div>
                </div>

            </div>
        </modal>
    </div>
</template>

<script>
    import Task from "../../models/v2/Task";
    import TaskComment from "@/models/v2/TaskComment";
    import Client from "@/models/Client";
    import _ from "underscore";

    export default {
        async beforeMount() {
            await this.loadData();
        },
        async beforeRouteUpdate(to, from, next) {
            next();
            await this.loadData();
        },
        components: {
            autocomplete: () => import('vue-bootstrap-typeahead'),
            Loading: () => import('vue-loading-overlay'),
            gridView: () => import('../data/table/GridView'),
            dropDownButton: () => import('../data/DropDownButton'),
        },
        data() {
            return {
                client: {
                    clientSearch: '',
                    list: [],
                },
                filter: {
                    client_id: 0,
                    type_id: '',
                    complete: 0,
                },
                directions: [],
                loader: Task.getList,
                modals: {
                    comments: {
                        isLoading: false,
                        list: [],
                        text: '',
                        task: new Task(),
                    },
                    help: {
                        task: new Task(),
                    },
                },
            };
        },
        methods: {
            async loadData() {

            },
            async loadComments() {
                this.modals.comments.isLoading = true;

                let commentsRequest = await TaskComment.getList(this.modals.comments.task.id);
                this.modals.comments.list = commentsRequest.data;

                this.modals.comments.isLoading = false;
            },
            async showCommentPopup(task) {
                this.modals.comments.task = task;
                this.modals.comments.text = '';
                this.modals.comments.list = [];
                this.$modal.show('task-comments');
                await this.loadComments()
            },
            showHelp(task) {
                this.modals.help.task = task;
                this.$modal.show('task-help');
            },
            async taskClose(task) {
                if (task.complete === 1) {
                    return;
                }
                let result;
                try {
                    result = await task.close();
                } catch (error) {
                    console.error(error);
                    result = false;
                }
                if (result === true) {
                    this.$notify({
                        text: 'Сохранено. Задача закрыта',
                    });
                } else {
                    this.$notify({
                        type: 'error',
                        text: 'Ошибка закрытия задачи',
                    });
                }
            },
            async submitComment() {
                if (this.modals.comments.text.length === 0) {
                    return;
                }
                let result;
                try {
                    result = await TaskComment.create(this.modals.comments.task.id, this.modals.comments.text);
                    this.modals.comments.text = '';
                    await this.loadComments();
                } catch (error) {
                    console.error(error);
                    result = false;
                }
                if (result === true) {
                    this.$notify({
                        text: 'Комментарий добавлен',
                    });
                } else {
                    this.$notify({
                        type: 'error',
                        text: 'Ошибка добавления комментария',
                    });
                }
            },
            async getClients(query) {
                const list = await Client.find(query);
                this.client.list = list;
            },
            clientSelect(client) {
                this.filter.client_id = client.id;
            },
        },
        watch: {
            'filter': {
                handler: function() {
                    this.$refs.tableList.load();
                },
                deep: true,
            },
            'client.clientSearch': _.debounce(function(query) {
                if (query.length < 3) {
                    if (query.length === 0) {
                        this.filter.client_id = 0;
                    }
                    return;
                }
                this.getClients(query)
            }, 500),
        },
        metaInfo() {
            return {
                title: 'Задачи - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
